<template>
  <DateTimePicker
    :key="item.uuid"
    class="w-full form-input--small"
    :value="item.response"
    :enable-date="item.params.date"
    :enable-time="item.params.time"
    @change="handleInput"
  />
</template>

<script>
  import DateTimePicker from '@/_legacy/components/DateTimePickerLocal.vue';

  export default {
    components: { DateTimePicker },

    props: {
      item: {
        type: Object,
        required: true,
      },
    },

    methods: {
      handleInput(value) {
        this.$store.commit('conduct/changeResponse', {
          item: this.item.uuid,
          response: value,
          responded: value !== null,
        });
      },
    },
  };
</script>
